module.exports = __webpack_public_path__ + "img/all.769ab36a.png";